import {
    Box,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@material-ui/core";
import React from "react";

import jsonUtils from "../../utils/jsonUtils";
import tratamentoUtils from "../../utils/tratamentoUtils";

const QuadroVisualizacaoListaVertical = (props) => {
    const quadro = props.quadro;
    const relatorio = props.relatorio;
    const quadroDado = quadro.quadroDados[0];

    const sizeTitle = props.sizeTitle ? props.sizeTitle : "h5";
    const sizeText = props.sizeText ? props.sizeText : 13;

    let nome = ["Meritos Política", "Demeritos Política"];
    let dados = [
        "nome",
        "empresa",
        "cnpj",
        "CNPJ",
        "documento",
        "informante",
        "credor",
    ];

    const getDado = (chave_json, tratamento, json, lista = false) => {
        let value = jsonUtils.getValor(chave_json, json, lista);
        if (
            !nome.includes(quadro.titulo) &&
            dados.includes(chave_json) &&
            props.is_anon
        ) {
            let x = value.substring(0, 4);
            let x1 = value
                .substring(4, value.length - 4)
                .replace(/([a-zA-Z\d])/g, "X");
            let x2 = value.substring(value.length - 4, value.length);
            value = x + x1 + x2;
        }
        if (tratamento && tratamento.includes(",limparLista3") && value) {
            try {
                value = tratamentoUtils.limparLista(
                    "limparLista3",
                    value,
                    quadroDado.parametros.atributos
                );
            } catch (e) {}
            tratamento.replace(",limparLista3", "");
        }

        return value != undefined
            ? tratamentoUtils.executarTratamento(tratamento, value)
            : lista
            ? []
            : "-";
    };

    let atributos = {};
    let nome_atributos = {};

    try {
        atributos = quadroDado.parametros.atributos;
        nome_atributos = quadroDado.parametros.nome_atributos;
    } catch (err) {}

    const lista =
        typeof quadroDado.dado == "string"
            ? getDado(quadroDado.dado, quadroDado.tratamento, relatorio, true)
            : getDado(
                  quadroDado.dado.chave_json,
                  quadroDado.tratamento,
                  relatorio,
                  true
              );

    const emptyRows = 5 - Math.min(5, lista.length);

    return (
        <Box className="zoomPrinter">
            <Typography variant={sizeTitle}>{quadro.titulo}</Typography>
            <Box style={{ paddingTop: "1rem", paddingBottom: "1rem" }}>
                <Paper elevation={0} variant="outlined">
                    <TableContainer className="boxPrinter">
                        <Table
                            aria-label="sticky table"
                            sx={{ minHeight: "18rem" }}
                            size="small"
                        >
                            <TableBody>
                                {nome_atributos.map((i, indexRow) => (
                                    <TableRow
                                        className="pageBreak"
                                        hover
                                        role="checkbox"
                                        tabIndex={-1}
                                        key={i}
                                    >
                                        <TableCell variant="head">
                                            <Box
                                                color="primaryDark.main"
                                                fontSize={sizeText}
                                            >
                                                <b>{i}</b>
                                            </Box>
                                        </TableCell>
                                        {lista.map((row, index) => (
                                            <TableCell key={index}>
                                                <Box
                                                    fontSize={sizeText}
                                                    whiteSpace="pre-wrap"
                                                >
                                                    {getDado(
                                                        atributos[indexRow]
                                                            .nome,
                                                        atributos[indexRow]
                                                            .tratamento,
                                                        row
                                                    )}
                                                </Box>
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Box>
        </Box>
    );
};

export default QuadroVisualizacaoListaVertical;
